import {
    GET_ALL_BOOKS,
    GET_STORY_LIST,
    GET_DATABANK,
    GET_BOOKS_FOR_STUDENT,
    ADD_BOOK_TO_STUDENT,
    DELETE_BOOK,
    SEARCH_FOR_BOOKS,
    SEARCH_FOR_BOOKS_FAIL,
    ROOT_URL,
    DOWNLOAD_BOOK_COMPLETE,
    DOWNLOAD_BOOK_FAIL,
    ADD_BOOK_TO_STUDENT_FAILED,
    BOOK_SHARE_LOGIN_VERIFED,
    GET_BOOKSHARE_USERS,
    ADD_BOOKSHARE_USER,
    STUDENT_BOOK_IMPORTED,
    REMOVE_IMPORTED_BOOK,
    REMOVE_STUDENT_BOOK,
    REMOVE_SEARCH_IMPORTED_BOOK,
    SEARCH_FOR_BOOKS_FOUND,
    RESET_IMPORT_MODAL,
    GET_BOOKSHARE_REQUEST_BOOKS,
    GET_BOOKSHARE_IDENTITY,
    GET_BOOKSHARE_IDENTITY_FAIL,
    REINITIALIZE_BOOKSHARE_IDENTITY,
    DELETE_BOOKSHARE_REQUEST_BOOK,
    SEARCH_FOR_BOOKS_START,
    REMOVE_FAILED_IMPORT_BOOK_ID,
    SAVE_IMPORTED_BOOK,
    RESET_BOOKLIST_TEMP,
    REINITIALIZE_IMPORT_MODAL,
    IMPORT_STORY_LIST,
    IMPORT_STORY_LIST_SUCCESS,
    IMPORT_STORY_LIST_FAIL
} from '../../constants';
import { saveAs } from 'file-saver';
import axios from 'axios';


export const getBooksForStudent = (studentId) => {
    const url = `${ROOT_URL}/students/${studentId}/story`;
    return (dispatch) => {
        axios
            .get(url)
            .then(response => {
                dispatch({
                    type: GET_BOOKS_FOR_STUDENT,
                    books: response.data
                })
            })
            .catch(err => console.log(err))
    }
}

// for books already in our OE catalog. call appears as the id number
export const addStoryToStudent = (studentId, bookId) => {
    const url = `${ROOT_URL}/students/${studentId}/story/${bookId}`;
    return (dispatch) => {
        axios
            .post(url)
            .then((response) => {
                console.log('addStoryToStudent', response.data);
                dispatch({
                    type: ADD_BOOK_TO_STUDENT,
                    book: response.data
                });
                dispatch({
                    type: STUDENT_BOOK_IMPORTED,
                    book: response.data
                })
            })
            .catch(err => {
                console.log("Import error", err)
                const errorMessage = err && err.response && err.response.data
                    ? err.response.data
                    : "Network error. Please check your connection.";
                const status = err && err.response && err.response.status
                    ? err.response.status
                    : 0;

                dispatch({
                    type: ADD_BOOK_TO_STUDENT_FAILED,
                    errorMessage: errorMessage,
                    status: status,
                    failedImportBookId: bookId
                });               
                // dispatch({
                //     type: BOOK_SHARE_LOGIN_VERIFED
                // })
            })
    };
}

// currently it's actually getting just the catalog books that are not added to the student yet. the api's includeSelf param set as true would return all books
export const getAllBooks = (studentId) => {
    console.log("called");
    const url = `${ROOT_URL}/students/${studentId}/story/databank`;
    return (dispatch) => {
        axios
            .get(url)
            .then((response) => {
                dispatch({
                    type: GET_ALL_BOOKS,
                    bookList: response.data
                })
            })
            .catch(err => console.log(err))
    };
}

export const getStoryList = () => {
    console.log("getStoryList called");
    const url = `${ROOT_URL}/story-list`;
    return (dispatch) => {
        axios
            .get(url)
            .then((response) => {
                dispatch({
                    type: GET_STORY_LIST,
                    storyList: response.data
                })
            })
            .catch(err => console.log(err))
    };
}

export const getDatabank = (studentId) => {
    console.log("getDatabanks called");
    const url = `${ROOT_URL}/students/${studentId}/story/databank`;
    return (dispatch) => {
        axios
            .get(url)
            .then((response) => {
                dispatch({
                    type: GET_DATABANK,
                    databank: response.data
                })
            })
            .catch(err => console.log(err))
    };
}

export const searchForBooks = (searchTerm, searchField) => {
    const url = `${ROOT_URL}/bookshare/search`;
    console.log(searchField, searchTerm);
    var data = {};
    data[searchField] = searchTerm;
    return (dispatch) => {
        axios.
            post(url, data)
            .then((response) => {
                dispatch({
                    type: SEARCH_FOR_BOOKS,
                    bookShareList: response.data
                });
                dispatch({
                    type: SEARCH_FOR_BOOKS_FOUND
                });
            })
            .catch(err => {
                console.log(err);
                dispatch({
                    type: SEARCH_FOR_BOOKS_FAIL
                })
            })
    };
}

export const searchForBooksStart = () => {

    return (dispatch) => {
        dispatch({
            type: SEARCH_FOR_BOOKS_START
        });
    };
}

export const toggleEchoType = (studentId, storyId) => {
    const url = `${ROOT_URL}/students/${studentId}/story/${storyId}/change-echo`;
    return (dispatch, getState) => {
        let state = getState();
        axios
            .post(url)
            .then((response) => {
                const { platform: { books } } = state;
                let newBooks = books.length > 0 && books.map((item) => {
                    if (item.name === response.data.name) {
                        return response.data;
                    }
                    return item;
                })
                console.log('books, newBooks, toggleBookType redux res ', books, newBooks, response.data);
                dispatch({
                    type: GET_BOOKS_FOR_STUDENT,
                    books: newBooks
                })
            })
            .catch(err => console.log(err))
    };
}

export const toggleBookType = (studentId, storyId) => {
    const url = `${ROOT_URL}/students/${studentId}/story/${storyId}/change-word-rate`;
    return (dispatch, getState) => {
        let state = getState();
        axios
            .post(url)
            .then((response) => {
                const { platform: { books } } = state;
                let newBooks = books.length > 0 && books.map((item) => {
                    if (item.name === response.data.name) {
                        return response.data;
                    }
                    return item;
                })
                console.log('books, newBooks, toggleBookType redux res ', books, newBooks, response.data);
                dispatch({
                    type: GET_BOOKS_FOR_STUDENT,
                    books: newBooks
                })
            })
            .catch(err => console.log(err))
    };
    
}

// Optimistic toggle functions
export const toggleBookTypeOptimistic = (studentId, storyId, currentBook) => {
    const url = `${ROOT_URL}/students/${studentId}/story/${storyId}/change-word-rate`;
    return (dispatch, getState) => {
        const { platform: { books } } = getState();
        // Per-request guard
        const requestId = `${Date.now()}_${Math.random().toString(36).slice(2,8)}`;

        // Optimistically update the UI immediately
        const optimisticBooks = books.map((item) => {
            if (item.id === storyId) {
                const newWordRate = item.wordRate === '75' ? '0' : '75';
                return { ...item, wordRate: newWordRate, pendingRequestId: requestId };
            }
            return item;
        });
        
        dispatch({
            type: GET_BOOKS_FOR_STUDENT,
            books: optimisticBooks
        });
        
        // Make the API call
        axios
            .post(url)
            .then((response) => {
                // Use the latest state and merge only if still current
                const { platform: { books: latestBooks } } = getState();
                const latestBook = latestBooks.find(function (b) { return b.id === storyId; });
                if (!latestBook || latestBook.pendingRequestId !== requestId) return; // stale
                const idToMatch = (response && response.data && response.data.id) ? response.data.id : storyId;
                const serverBooks = latestBooks.map((item) => (
                    item.id === idToMatch ? response.data : { ...item, pendingRequestId: item.id === storyId ? undefined : item.pendingRequestId }
                ));
                dispatch({
                    type: GET_BOOKS_FOR_STUDENT,
                    books: serverBooks
                });
            })
            .catch(err => {
                console.error('toggleBookTypeOptimistic failed, rolling back:', err);
                // Rollback only the affected book and clear pending
                const { platform: { books: latestBooks } } = getState();
                const latestBook = latestBooks.find(function (b) { return b.id === storyId; });
                if (!latestBook || latestBook.pendingRequestId !== requestId) return; // stale
                const rolledBack = latestBooks.map((item) => (
                    item.id === storyId ? { ...item, wordRate: currentBook.wordRate, pendingRequestId: undefined } : item
                ));
                dispatch({
                    type: GET_BOOKS_FOR_STUDENT,
                    books: rolledBack
                });
            });
    };
};

export const toggleEchoTypeOptimistic = (studentId, storyId, currentBook) => {
    const url = `${ROOT_URL}/students/${studentId}/story/${storyId}/change-echo`;
    return (dispatch, getState) => {
        const { platform: { books } } = getState();
        // Per-request guard
        const requestId = `${Date.now()}_${Math.random().toString(36).slice(2,8)}`;
        
        // Optimistically update the UI immediately
        const optimisticBooks = books.map((item) => {
            if (item.id === storyId) {
                const newWordRate = item.wordRate === '-1' ? '0' : '-1';
                return { ...item, wordRate: newWordRate, pendingRequestId: requestId };
            }
            return item;
        });
        
        dispatch({
            type: GET_BOOKS_FOR_STUDENT,
            books: optimisticBooks
        });
        
        // Make the API call
        axios
            .post(url)
            .then((response) => {
                // API success - update with server response using latest state
                const { platform: { books: latestBooks } } = getState();
                const latestBook = latestBooks.find(function (b) { return b.id === storyId; });
                if (!latestBook || latestBook.pendingRequestId !== requestId) return; // stale
                const idToMatch = (response && response.data && response.data.id) ? response.data.id : storyId;
                const serverBooks = latestBooks.map((item) => (
                    item.id === idToMatch ? response.data : { ...item, pendingRequestId: item.id === storyId ? undefined : item.pendingRequestId }
                ));
                dispatch({
                    type: GET_BOOKS_FOR_STUDENT,
                    books: serverBooks
                });
            })
            .catch(err => {
                console.error('toggleEchoTypeOptimistic failed, rolling back:', err);
                // API failed - rollback only the affected item to its previous state and clear pending
                const { platform: { books: latestBooks } } = getState();
                const latestBook = latestBooks.find(function (b) { return b.id === storyId; });
                if (!latestBook || latestBook.pendingRequestId !== requestId) return; // stale
                const rolledBack = latestBooks.map((item) => (
                    item.id === storyId ? { ...item, wordRate: currentBook.wordRate, pendingRequestId: undefined } : item
                ));
                dispatch({
                    type: GET_BOOKS_FOR_STUDENT,
                    books: rolledBack
                });
            });
    };
};

// Special action for switching from Sentence+Echo to Paragraph mode
export const switchFromEchoToParagraphMode = (studentId, storyId, currentBook) => {
    const echoUrl = `${ROOT_URL}/students/${studentId}/story/${storyId}/change-echo`;
    const wordRateUrl = `${ROOT_URL}/students/${studentId}/story/${storyId}/change-word-rate`;
    
    return (dispatch, getState) => {
        const { platform: { books } } = getState();
        
        // Generate a per-request id to guard against out-of-order responses
        const requestId = `${Date.now()}_${Math.random().toString(36).slice(2,8)}`;
        let confirmedWordRate = null; // will hold server-confirmed intermediate state
        
        // Optimistically update both toggles immediately (Echo OFF + Paragraph mode)
        const optimisticBooks = books.map((item) => {
            if (item.id === storyId) {
                return { ...item, wordRate: '75', pendingRequestId: requestId }; // Paragraph mode (Echo is automatically OFF)
            }
            return item;
        });
        
        dispatch({
            type: GET_BOOKS_FOR_STUDENT,
            books: optimisticBooks
        });
        
        // Step 1: Echo OFF
        axios.post(echoUrl)
            .then(() => {
                confirmedWordRate = '0'; // After echo off, server is effectively in Sentence mode
                // Step 2: change passage length to Paragraph
                return axios.post(wordRateUrl);
            })
            .then((wordRateResponse) => {
                // Apply only if this is still the latest request for this book
                const { platform: { books: latestBooks } } = getState();
                const latestBook = latestBooks.find(function (b) { return b.id === storyId; });
                if (latestBook && latestBook.pendingRequestId === requestId) {
                    const idToMatch = (wordRateResponse && wordRateResponse.data && wordRateResponse.data.id) ? wordRateResponse.data.id : storyId;
                    const finalBooks = latestBooks.map((item) => (
                        item.id === idToMatch ? wordRateResponse.data : { ...item, pendingRequestId: item.id === storyId ? undefined : item.pendingRequestId }
                    ));
                    dispatch({
                        type: GET_BOOKS_FOR_STUDENT,
                        books: finalBooks
                    });
                }
                // else drop stale response
            })
            .catch((err) => {
                console.error('Echo→Paragraph sequence failed:', err);
                const { platform: { books: latestBooks } } = getState();
                const latestBook = latestBooks.find(function (b) { return b.id === storyId; });
                if (!latestBook || latestBook.pendingRequestId !== requestId) {
                    return; // A newer request superseded this one; do nothing
                }
                const rollbackWordRate = confirmedWordRate !== null ? confirmedWordRate : currentBook.wordRate;
                const rolledBack = latestBooks.map((item) => (
                    item.id === storyId ? { ...item, wordRate: rollbackWordRate, pendingRequestId: undefined } : item
                ));
                dispatch({
                    type: GET_BOOKS_FOR_STUDENT,
                    books: rolledBack
                });
            });
    };
};

// Special action for switching from Paragraph mode to Sentence+Echo mode
export const switchFromParagraphToEchoMode = (studentId, storyId, currentBook) => {
    const wordRateUrl = `${ROOT_URL}/students/${studentId}/story/${storyId}/change-word-rate`;
    const echoUrl = `${ROOT_URL}/students/${studentId}/story/${storyId}/change-echo`;
    
    return (dispatch, getState) => {
        const { platform: { books } } = getState();
        
        // Generate a per-request id to guard against out-of-order responses
        const requestId = `${Date.now()}_${Math.random().toString(36).slice(2,8)}`;
        let confirmedWordRate = null; // will hold server-confirmed intermediate state ('0' after P→S)
        
        // Optimistically show Echo ON immediately (Sentence + Echo)
        const echoOnImmediate = books.map((item) => {
            if (item.id === storyId) {
                return { ...item, wordRate: '-1', pendingRequestId: requestId };
            }
            return item;
        });
        
        dispatch({
            type: GET_BOOKS_FOR_STUDENT,
            books: echoOnImmediate
        });
        
        // First ensure backend moves from Paragraph → Sentence
        axios.post(wordRateUrl)
            .then(() => {
                confirmedWordRate = '0'; // server is now in Sentence (echo still off)
                // Then enable Echo on backend
                return axios.post(echoUrl);
            })
            .then((echoResponse) => {
                // Apply only if this is still the latest request for this book
                const { platform: { books: latestBooks } } = getState();
                const latestBook = latestBooks.find(function (b) { return b.id === storyId; });
                if (latestBook && latestBook.pendingRequestId === requestId) {
                    const idToMatch = (echoResponse && echoResponse.data && echoResponse.data.id) ? echoResponse.data.id : storyId;
                    const finalBooks = latestBooks.map((item) => (
                        item.id === idToMatch ? echoResponse.data : { ...item, pendingRequestId: item.id === storyId ? undefined : item.pendingRequestId }
                    ));
                    dispatch({
                        type: GET_BOOKS_FOR_STUDENT,
                        books: finalBooks
                    });
                }
                // else drop stale response
            })
            .catch((err) => {
                console.error('Paragraph→Echo sequence failed:', err);
                const { platform: { books: latestBooks } } = getState();
                const latestBook = latestBooks.find(function (b) { return b.id === storyId; });
                if (!latestBook || latestBook.pendingRequestId !== requestId) {
                    return; // A newer request superseded this one; do nothing
                }
                const rollbackWordRate = confirmedWordRate !== null ? confirmedWordRate : currentBook.wordRate;
                const rolledBack = latestBooks.map((item) => (
                    item.id === storyId ? { ...item, wordRate: rollbackWordRate, pendingRequestId: undefined } : item
                ));
                dispatch({
                    type: GET_BOOKS_FOR_STUDENT,
                    books: rolledBack
                });
            });
    };
};

export const deleteBook = (studentId, book) => {
    const url = `${ROOT_URL}/students/${studentId}/story`;
    return (dispatch) => {
        axios
            .delete(url, {data: book})
            .then(()=> {
                dispatch({
                    type: DELETE_BOOK,
                    book
                });
                dispatch({
                    type: REMOVE_IMPORTED_BOOK,
                    payload: book
                });
                dispatch({
                    type: REMOVE_STUDENT_BOOK,
                    payload: book
                });
                dispatch({
                    type: REMOVE_SEARCH_IMPORTED_BOOK,
                    payload: book
                });
                dispatch({
                    type: RESET_IMPORT_MODAL
                })
            })
            .catch(err => console.log(err))
    }
}

// for books that are not in our OE catalog. and adding from bookshare
export const downloadBook = (bookId, studentId, book) => {
    console.log('download from action starts');
    const url = `${ROOT_URL}/bookshare/download/${bookId}/for/${studentId}`;
    return (dispatch) => {
        console.log('download calling');
        axios
            .post(url, { responseType: 'blob' })
            .then((response) => {
                const newBook={...book,name:book.title, description:book.synopsis};
                dispatch({
                    type:  DOWNLOAD_BOOK_COMPLETE
                });
                dispatch({
                    type: STUDENT_BOOK_IMPORTED,
                    book: newBook
                });
            })
            .catch(err => {
                console.log('download from action err res',err);
                const errorMessage = err && err.response && err.response.data
                    ? err.response.data
                    : "Network error. Please check your connection.";
                const status = err && err.response && err.response.status
                    ? err.response.status
                    : 0;

                dispatch({
                    type: DOWNLOAD_BOOK_FAIL
                })
                dispatch({
                    type: ADD_BOOK_TO_STUDENT_FAILED,
                    errorMessage: errorMessage,
                    status: status,
                    failedImportBookId: bookId
                });
                dispatch({
                    type: SEARCH_FOR_BOOKS_FOUND
                });              
                // dispatch({
                //     type: BOOK_SHARE_LOGIN_VERIFED
                // });
            });
    }
}

export const removeFailedImportBookId = (bookId) => ({
    type: REMOVE_FAILED_IMPORT_BOOK_ID,
    bookId
});

export const resetScore = (studentId, bookId) => {
    const  url = `${ROOT_URL}/students/${studentId}/story/${bookId}/progress`;
    return axios.delete(url);
}


export const getBookShareUsers = () => {
    const url = `${ROOT_URL}/bookshare/users`;
    return (dispatch) => {
        axios.get(url)
            .then(res => {
                dispatch({
                    type: GET_BOOKSHARE_USERS,
                    data: res.data
                })
            })
            .catch(err => {
                console.error('getBookShareUsers action: FAILED - API call error:', err);
                console.error('getBookShareUsers action: Error response:', err.response);
                console.error('getBookShareUsers action: Error status:', err.response && err.response.status);
                console.error('getBookShareUsers action: Error data:', err.response && err.response.data);
            });
    }
}

export const addBookShareUser = (studentId, user) => {
    const url = `${ROOT_URL}/bookshare/assign/${studentId}`;
    return (dispatch) => {
        axios.post(url, user).then(res => {
            dispatch({
                type: ADD_BOOKSHARE_USER
            })
        }
        ).catch(e => console.log("ERROR", e.response.data));
    }
}
export const addStudentToBookshare =(studentId, user) => {
    const url = `${ROOT_URL}/bookshare/student/${studentId}`;
    return (dispatch) => {
        axios.post(url, user).then(res => {
            dispatch({
                type: ADD_BOOKSHARE_USER
            })
        }
        ).catch(e => console.log("ERROR", e.response.data));
    }
}

export const getBookshareRequestedBooks = (studentId) => {
    const url = `${ROOT_URL}/bookshare/${studentId}/requests`;
    return (dispatch) => {
        axios.get(url).then(res => {
            dispatch({
                type: GET_BOOKSHARE_REQUEST_BOOKS,
                data: res.data
            })
        }
        );
    }
}

export const getBookShareIdentity = () => {
    const url = `${ROOT_URL}/bookshare/bookshare-identity`;
    return (dispatch) => {
        axios.get(url).then(res => {
            dispatch({
                type: GET_BOOKSHARE_IDENTITY,
                data: res.data
            })
        })
        .catch(err => {
            dispatch({
                type: GET_BOOKSHARE_IDENTITY_FAIL
            })
        })
    }
}

export const reinitializeBookShareIdentity = () => {
    return (dispatch) => {
        dispatch({
            type: REINITIALIZE_BOOKSHARE_IDENTITY
        })
    }
}

export const deleteBookshareRequestedBook = (studentId, storyRequestId) => {
    const url = `${ROOT_URL}/bookshare/${studentId}/requests/${storyRequestId}`;
    return (dispatch) => {
        axios
            .delete(url)
            .then((res)=> {
                dispatch({
                    type: DELETE_BOOKSHARE_REQUEST_BOOK,
                    id:storyRequestId
                })
            })
            .catch(err => console.log(err))
    }
}

export const importStoryList = (studentId, storyListId) => {
    const url = `${ROOT_URL}/students/${studentId}/story/story-list/${storyListId}`;
    return (dispatch) => {
        dispatch({
            type: IMPORT_STORY_LIST
        });
        
        axios
            .post(url)
            .then((response) => {
                dispatch({
                    type: IMPORT_STORY_LIST_SUCCESS,
                    payload: response.data
                });
            })
            .catch(err => {
                console.log('Import story list error:', err);
                const errorMessage = err && err.response && err.response.data
                    ? err.response.data
                    : "Network error. Please check your connection.";
                const status = err && err.response && err.response.status
                    ? err.response.status
                    : 0;

                dispatch({
                    type: IMPORT_STORY_LIST_FAIL,
                    errorMessage: errorMessage,
                    status: status
                });
            });
    };
};

// Quick Action: Change Reading Mode
export const changeReadingMode = (studentId) => {
    const url = `${ROOT_URL}/students/${studentId}/story/change-reading-mode`;
    return (dispatch) => {
        return axios
            .post(url)
            .then((response) => {
                console.log('Change reading mode successful:', response.data);
                return response.data;
            })
            .catch(err => {
                console.error('Change reading mode failed:', err);
                const errorMessage = err && err.response && err.response.data
                    ? err.response.data
                    : "Network error. Please check your connection.";
                throw new Error(errorMessage);
            });
    };
};

// Quick Action: Change Reading Mode Up (Direction: 1)
export const changeReadingModeUp = (studentId) => {
    const url = `${ROOT_URL}/students/${studentId}/story/change-reading-mode?changeDirection=-1`;
    return (dispatch) => {
        return axios
            .post(url)
            .then((response) => {
                console.log('Change reading mode UP successful:', response.data);
                return response.data;
            })
            .catch(err => {
                console.error('Change reading mode UP failed:', err);
                const errorMessage = err && err.response && err.response.data
                    ? err.response.data
                    : "Network error. Please check your connection.";
                throw new Error(errorMessage);
            });
    };
};

// Quick Action: Change Reading Mode Down (Direction: -1)
export const changeReadingModeDown = (studentId) => {
    const url = `${ROOT_URL}/students/${studentId}/story/change-reading-mode?changeDirection=1`;
    return (dispatch) => {
        return axios
            .post(url)
            .then((response) => {
                console.log('Change reading mode DOWN successful:', response.data);
                return response.data;
            })
            .catch(err => {
                console.error('Change reading mode DOWN failed:', err);
                const errorMessage = err && err.response && err.response.data
                    ? err.response.data
                    : "Network error. Please check your connection.";
                throw new Error(errorMessage);
            });
    };
};

// Quick Action: Acknowledge quick action by key
export const acknowledgeQuickAction = (studentId, key) => {
    const url = `${ROOT_URL}/students/${studentId}/buddy-books/dashboard/new/acknowledge-quickaction?key=${encodeURIComponent(key)}`;
    return (dispatch) => {
        return axios
            .post(url)
            .then((response) => {
                console.log('Acknowledge quick action successful:', response.data);
                return response.data;
            })
            .catch(err => {
                console.error('Acknowledge quick action failed:', err);
                const errorMessage = err && err.response && err.response.data
                    ? err.response.data
                    : "Network error. Please check your connection.";
                throw new Error(errorMessage);
            });
    };
};

// Quick Action: Change BuddyBooks Level Up (Progress)
export const changeBuddyBooksLevelUp = (studentId) => {
    const url = `${ROOT_URL}/students/${studentId}/story/change-buddybooks-level?changeDirection=1`;
    return (dispatch) => {
        return axios
            .post(url)
            .then((response) => {
                console.log('Change BuddyBooks level up successful:', response.data);
                return response.data;
            })
            .catch(err => {
                console.error('Change BuddyBooks level up failed:', err);
                const errorMessage = err && err.response && err.response.data
                    ? err.response.data
                    : "Network error. Please check your connection.";
                throw new Error(errorMessage);
            });
    };
};

// Quick Action: Change BuddyBooks Level Down (Adjustment)
export const changeBuddyBooksLevelDown = (studentId) => {
    const url = `${ROOT_URL}/students/${studentId}/story/change-buddybooks-level?changeDirection=-1`;
    return (dispatch) => {
        return axios
            .post(url)
            .then((response) => {
                console.log('Change BuddyBooks level down successful:', response.data);
                return response.data;
            })
            .catch(err => {
                console.error('Change BuddyBooks level down failed:', err);
                const errorMessage = err && err.response && err.response.data
                    ? err.response.data
                    : "Network error. Please check your connection.";
                throw new Error(errorMessage);
            });
    };
};